/**
 * 2019-04-13
 * handan
 * 一些状态的弹框
 */

import React, { Component } from 'react'
import { connect } from "react-redux";
import { Modal } from "antd";
import "./style.scss";

import { fixWithMoney,getRechargeList, chargeAndPay } from "../../models";

class ModalPop extends Component{
  constructor(props){
    super(props)
    this.state = {
      isShowModal: false,
      rechargeList: [],
    }
    this.onclickPay = this.onclickPay.bind(this);
    this.onCloseModel = this.onCloseModel.bind(this);
    // this.onOk = this.onOk.bind(this);
    this.handleRecharge = this.handleRecharge.bind(this);
  }
  // 支付弹框
  payPop(){
    const { rechargeList=[] } = this.state;
    const { popData={} } = this.props;
    const { params={}, pointSum=0, originalPrice=0 } = popData;
    let isPointVoid = pointSum===0;
    // const rechargeList = [
    //   {
    //     "id": 5,
    //     "rechargeName": "220",
    //     "addPoints": 220,
    //     "originalPrice": 1100,
    //     "salePrice": 599,
    //     "discountRate": 5.4,
    //     "addedDesc": "80%人的选择",
    //     "delete": false
    //   },
    //   {
    //     "id": 10,
    //     "rechargeName": "220",
    //     "addPoints": 220,
    //     "originalPrice": 1100,
    //     "salePrice": 599,
    //     "discountRate": 5.4,
    //     "addedDesc": "80%人的选择",
    //     "delete": false
    //   },
    //   { "id": 20, "rechargeName": "105", "addPoints": 105, "originalPrice": 525, "salePrice": 299, "discountRate": 5.7, "addedDesc": "", "delete": false },
    //   { "id": 30, "rechargeName": "33", "addPoints": 33, "originalPrice": 165, "salePrice": 99, "discountRate": 6, "addedDesc": "", "delete": false }];
    return (
      <div className="payPop">
        <div className="top">
          <p className="title"> { isPointVoid ? "本次需支付" : `余额不足！当前余额${pointSum}点，需支付${params.costPoint}点` } </p>
          <p className="nowPrice">
            <em>¥</em>{params.orderMoney}
          </p>
          {
            isPointVoid ?
            <p className="oldPrice">请充值或单次支付</p>:
            <p className="oldPrice through">原价¥{originalPrice}</p>
          }
          <button onClick={this.onclickPay}>立即支付</button>
        </div>
        <div className="bottom">
          <p className="prompt">
          充值背调点数，立享超值优惠
          </p>
          <ul>
            {
              rechargeList.map((item)=>{
                return (
                  <li key={item.id} className="active">
                    <div className="item">
                      {/* {item.id === 5
                          &&
                          <img
                            style={{position: 'absolute',top:'-35px', left:'1px'}} 
                            src="//pic1.58cdn.com.cn/nowater/cxnomark/n_v23c3ec5b5f2e846039aa7b91734c41dc3.png"
                          />
                      } */}
                      {/* <div className="sheng">立省{item.originalPrice-item.salePrice}元</div> */}
                      <div className="item-content">
                        <p className="title">{item.rechargeName}背调点数</p>
                        <p className="price">
                          <span>¥{item.salePrice}</span>
                          {/* <em>原价¥{item.originalPrice}</em> */}
                        </p>
                      </div>
                      <button onClick={()=>{this.handleRecharge(item.id)}}>立即充值</button>
                      {/* <p className="zhe">{item.discountRate}折</p> */}
                    </div>
                  </li>
                )
              })
            }
          </ul>
        </div>
      </div>
    )
  }
  // 状态弹框
  statePop(){
    const { popData={} } = this.props;
    const { data={}, isSuccess=false} = popData
    let classname = isSuccess ? "good" : "bad"
    return (
      <div className={"statePop "+classname}>
        <p className="bgIcon"></p>
        <p className="name">{data.title}</p>
        <span dangerouslySetInnerHTML={{__html: data.text }}></span>
        <button onClick={this.onCloseModel}>{data.buttonText}</button>
      </div>
    )
  }
  render(){
    const { popData={} } = this.props;
    const { isShowModal=false, isPayModal=false,isOk=false, } = popData;
    return (
      <Modal
        visible={isShowModal}
        onCancel={this.onCloseModel}
        // onOk={ isOk ? this.onOk : null}
        // onOk={this.onOk}
        wrapClassName="myModal"
        footer={null}
        centered={true}
        width={isPayModal ? 900 : 480}
      >
      {
        isPayModal ? this.payPop() : this.statePop()
      }
      </Modal>
    )
  }
  componentDidMount(){
    getRechargeList().then((data)=>{
      this.setState({
        rechargeList: data
      })
    }).catch(()=>{})
  }

  // 支付弹框，去支付
  onclickPay(){
    const { setPopData, popData={}, setLoadingState } = this.props;
    const { params={} } = popData;
    let title = "支付" ;
    setLoadingState(true);
    fixWithMoney(params).then((res)=>{
      // 带参数去跳转支付
      window.open(res,"_self");
      setLoadingState(false);
      let popData= {
        isOk: true,
      }
      setPopData(popData)
      this.onCloseModel(true);
    }).catch(()=>{
      let popData= {
        isShowModal: true,
        isPayModal: false,
        isSuccess: false,
        data: {
          title: `${title}失败`,
          text: `请检查网络或重新支付`,
          buttonText: "关闭"
        }
      }
      setLoadingState(false);
      setPopData(popData)
    })
  }

  // 充值并支付
  handleRecharge(rechargeId){
    const { setPopData, popData={}, setLoadingState } = this.props;
    const { params={} } = popData;
    let obj = {
      ...params,
      rechargeId,
      rechargeType: 2,
    }
    let title = "充值" ;
    setLoadingState(true);
    chargeAndPay(obj).then((data)=>{
      window.open(data,"_self")
      setLoadingState(false);
      this.onCloseModel();
    }).catch(()=>{
      let popData= {
        isShowModal: true,
        isPayModal: false,
        isSuccess: false,
        data: {
          title: `${title}失败`,
          text: `请检查网络或重新支付`,
          buttonText: "关闭"
        }
      }
      setLoadingState(false);
      setPopData(popData)
    })
  }

  // 关闭弹框
  onCloseModel(flag){
    const { popData={} } = this.props;
    const { isOk=false, } = popData;
    const { setPopData } = this.props;
    setPopData({
      isShowModal:false
    })
    if(isOk){
      this.props.history.push('/resultHistory');
      return;
    }
    if(flag){
      this.props.history.push('/resultHistory');
      return
    }
    
  }

}

const mapState = (store) => {
  return {
    popData: store.modalPop,
  }
}
const mapDispatch = (dispatch) => {
  return {
    setPopData(data){
      dispatch({
        type: "setPopData",
        data,
      })
    },
    setLoadingState(data){
      dispatch({
        type: "setLoadingState",
        data
      })
    }
  }
}
export default connect(mapState, mapDispatch)(ModalPop);